import { useEffect, Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { StoreState } from 'store/ducks';
import ChannelList from 'components/channelList/ChannelList';
import { ChatWrapperLayout } from 'components/common/layoutStyle';
import { chatSocketInit } from 'utils/socket/chatSocket';
import { socketStore } from 'utils/socket/socketStore';
import { jwtDecoder, validateToken, getAccToken } from 'utils/auth/tokenUtils';
import { tokenUpdateInterval } from 'utils/auth/tokenAPI';
import { getSupportRegion } from 'utils/snippet';

import ChatMain from 'components/chatMain/ChatMain';
import Footer from 'components/footer/Footer';
import { AuthAPI } from 'utils/httpAPI';
import { OIDCUserInfoResponse, QRUserInfoResponse } from 'types/apiTypes';
import ReduxPortalPopup from 'components/common/ReduxPortalPopup';
import ReduxModal from 'components/common/ReduxModal';
import ToastPopup from 'components/common/ToastPopup';

const MainForSPA = () => {
  const dispatch = useDispatch();
  const storeAccessToken = useSelector((state: StoreState) => state.authStore.storeAccessToken);
  const oidcAccessToken = useSelector((state: StoreState) => state.authStore.oidcAccessToken);
  useEffect(() => {
    const decodedAccToken = jwtDecoder(storeAccessToken);
    if (decodedAccToken && validateToken(decodedAccToken)) {
      dispatch({
        type: 'user/setOnlyUserData',
        payload: { id: decodedAccToken?.uid, nick: decodedAccToken?.unk },
      });
      if (socketStore.chatSocket === null) {
        const allowRegion = getSupportRegion();
        socketStore.chatSocket = chatSocketInit({ authentication: { qrToken: storeAccessToken }, region: allowRegion });
        tokenUpdateInterval();
      }
    } else if (oidcAccessToken) {
      if (socketStore.chatSocket === null) {
        const allowRegion = getSupportRegion();
        socketStore.chatSocket = chatSocketInit({ authentication: { accessToken: oidcAccessToken }, region: allowRegion });
      }
    }
  }, [dispatch, storeAccessToken, oidcAccessToken]);
  useEffect(() => {
    const allowRegion = getSupportRegion();
    if (oidcAccessToken) {
      AuthAPI.getUserInfo(oidcAccessToken, allowRegion, 'oidc').then((res) => {
        const { data } = res as { data: OIDCUserInfoResponse };
        const nickname = data.karrot_user.karrot_user_profile?.nickname;
        const proImage = data.karrot_user.karrot_user_profile?.profile_picture_url;
        
        if (nickname) {
          dispatch({
            type: 'user/setOnlyUserData',
            payload: { nick: nickname },
          });
        }
        
        if (proImage) {
          dispatch({
            type: 'user/setProfileImage',
            payload: proImage,
          });
        }
      }).catch((error) => {
        console.error('getUserInfo failed with oidcAccessToken:', error);
      });
    } else if (storeAccessToken) {
      AuthAPI.getUserInfo(storeAccessToken, allowRegion, 'qr').then((res) => {
        const { data } = res as { data: QRUserInfoResponse };
        const proImage = data.profile_image;
        if (proImage) {
          dispatch({
            type: 'user/setProfileImage',
            payload: proImage,
          });
        }
      }).catch((error) => {
        console.error('getUserInfo failed with storeAccessToken:', error);
      });
    }
  }, [dispatch, storeAccessToken, oidcAccessToken]);

  return (
    <Fragment>
      <ChatWrapperLayout>
        <div>
          <ReduxPortalPopup />
          <ReduxModal />
        </div>
        <ChannelList />
        <ChatMain />
        <ToastPopup />
      </ChatWrapperLayout>
      <Footer />
    </Fragment>
  );
};

export default MainForSPA;
